import React from "react"
import DataTypeHelper from '../dataTypes/DataTypeHelper'

class RevisionHistoryRow extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      checked: this.props.checked
    }
    this.toggleCheckbox = this.toggleCheckbox.bind(this)
  }

  render() {
    var checkBox;

    if(this.props.table_actions && this.props.table_actions.length > 0) {
      checkBox = <td key='checkbox_col' className="col-md-1 col-checkbox"><input type="checkbox" value={this.props.row.id ? this.props.row.id : JSON.stringify(this.props.row.id_fields)} checked={this.state.checked} onChange={this.toggleCheckbox} /></td>
    }

    return (
      <tr key={this.props.row.id} >
        {checkBox}
        <td style={{ width: (100 / this.props.headers.length) + '%'}}>{DataTypeHelper.renderColumn("DateTime", this.props.row.created_at, this.props)}</td>
        <td style={{ width: (100 / this.props.headers.length) + '%'}}>{DataTypeHelper.renderColumn("User", this.props.row.user, this.props)}</td>
        {this.props.row.no_modal ? <td></td> : <td style={{width: '33.3333%'}} className="text-right"><a href={this.props.row.show_or_revert_path} className="btn btn-secondary btn-xs modal-iframe" data-fullscreen="true">{I18n.t('view')}</a></td>}
      </tr>
    );
  }

  toggleCheckbox() {
    var self = this;
    this.setState({ checked: this.state.checked ? false : true }, function () {
      if (typeof self.props.onToggleCheckbox == 'function') {
        self.props.onToggleCheckbox(self.state.checked, self.props.row.id ? self.props.row.id : JSON.stringify(self.props.row.id_fields));
      }
    });
  }

};

export default RevisionHistoryRow